const refreshPage = (rute) => {
    window.location.replace(rute)
}


// Separador de miles
const numberObject = new Intl.NumberFormat('es-ES');

export { refreshPage, numberObject }